var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VRow',{staticClass:"page__row fill-height align-top pa-sm-2 pa-md-4"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }